// import React from "react";

// const sizeClasses = {
//   // xs: "w-fit min-w-7 h-7 px-2 py-1 text-xs leading-none ",
//   // "xs-sm": "w-fit min-w-8 h-8 px-2 py-1 text-xs leading-none",
//   // sm: "w-fit min-w-9 h-9 px-2 py-1 text-sm leading-none",
//   // md: "w-fit min-w-10 h-10 px-3 py-1 text-md leading-none",
//   // lg: "w-fit min-w-11 h-11 px-3 py-1 text-lg leading-none",
//   // xl: "w-fit min-w-12 h-12 px-3 py-1 text-xl leading-none",

//   xs: "w-fit min-w-5 h-5 text-xs",
//   "xs-sm": "w-fit min-w-6 h-6 text-xs",
//   sm: "w-fit min-w-7 h-7 text-xs",
//   md: "w-fit min-w-8 h-8 text-sm",
//   lg: "w-fit min-w-9 h-9 text-xl",
//   xl: "w-fit min-w-12 h-12 text-lg",
//   xxl: "w-[52px] h-[52px] text-2xl",
//   "3xl": "w-[64px] h-[64px] text-3xl",
//   "4xl": "w-[80px] h-[80px] text-4xl",
//   "5xl": "w-[120px] h-[120px] text-5xl",
// };

// const InfoCircle = ({
//   size = "md", //xs, xs-sm, sm, md, lg, xl
//   backgroundColor = "primary", // primary, warning, success, danger, info, black, white
//   colorShade = "500", //50-900
//   textColor = "black", // primary, warning, success, danger, info, black, white
//   value = "",
//   border = "contained", //contained, outlined
//   // borderSize = "0px", // 1px, 2px, 3px
//   // borderColor = "primary", // primary, warning, success, danger, info, black, white
// }) => {
//   const borderStyles = {
//     outlined: `border border-[1px] border-${backgroundColor}`,
//     contained: `border border-[0px]`,
//   };

//   return (
//     <div
//       className={`flex items-center justify-center ${sizeClasses[size]} rounded-full
//                text-${textColor} bg-${backgroundColor}-${colorShade}
//                ${borderStyles[border]}`}
//     >
//       <p>{value}</p>
//     </div>
//   );
// };

// export default InfoCircle;

import React from "react";

const sizeClasses = {
  xs: "w-fit min-w-5 h-5 text-[8px]",
  "xs-sm": "w-fit min-w-6 h-6 text-[10px]",
  sm: "w-fit min-w-7 h-7 text-xs",
  md: "w-fit min-w-8 h-8 text-sm",
  lg: "w-fit min-w-9 h-9 text-sm",
  xl: "w-fit min-w-12 h-12 text-base",
  xxl: "w-fit min-w-[52px] h-[52px] text-lg",
  "3xl": "w-fit min-w-[64px] h-[64px] text-2xl",
  "4xl": "w-fit min-w-[80px] h-[80px] text-4xl",
  "5xl": "w-fit min-w-[120px] h-[120px] text-5xl",
};

const borderClasses = {
  xs: "border-[1px]",
  "xs-sm": "border-[1px]",
  sm: "border-[1px]",
  md: "border-[1px]",
  lg: "border-[2px]",
  xl: "border-[2px]",
  xxl: "border-[2px]",
  "3xl": "border-[2px]",
  "4xl": "border-[2px]",
  "5xl": "border-[2px]",
};

const InfoCircle = ({
  value = "",
  size = "md",
  color = "primary", // primary, warning, success, danger, info, black, white
  colorDepth = "500", // 50,100,200,300,400,500,600,700,800,900
  variant = "contained", // contained, outlined
  noBorder = false,
  className = "",
  prefix,
  onClick,
}) => {
  // convert value to number
  const numberValue = Number(value);

  //if numberValue >99 px will be change based on the size

  const paddingClasses = {
    xs: "px-0.5 py-1",
    "xs-sm": "px-0.5 py-1",
    sm: "px-0.5 py-0.5",
    md: "px-0.5 py-1",
    lg: "px-1 py-1",
    xl: "px-1 py-1",
    xxl: "px-1 py-1",
    "3xl": "px-2 py-1",
    "4xl": "px-2 py-1",
    "5xl": "px-2 py-1",
  };

  const getDynamicPadding = (size, numberValue) => {
    const basePadding = paddingClasses[size];

    if (numberValue > 99) {
      // For values > 99, increase padding to accommodate larger numbers
      const largePaddingClasses = {
        xs: "px-1 py-1",
        "xs-sm": "px-1 py-1",
        sm: "px-1 py-1",
        md: "px-1.5 py-1",
        lg: "px-1.5 py-1",
        xl: "px-2 py-1",
        xxl: "px-2 py-1",
        "3xl": "px-2.5 py-1",
        "4xl": "px-3 py-1",
        "5xl": "px-3 py-1",
      };
      return largePaddingClasses[size] || basePadding;
    }

    return basePadding;
  };

  const getNextColorDepth = (currentDepth) => {
    const depths = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
    const currentIndex = depths.indexOf(Number(currentDepth));

    if (currentIndex === -1) return "500"; // fallback

    // If 900 or 800, return 900
    if (["800", "900"].includes(String(currentDepth))) {
      return "900";
    }

    // Jump two steps ahead, clamp to last index (900)
    const nextIndex = Math.min(currentIndex + 2, depths.length - 1);
    return String(depths[nextIndex]);
  };

  const getTextColor = (depth) => {
    return Number(depth) < 400 ? "black" : "white";
  };

  const updateColorDepth = (variant, colorDepth) => {
    return variant === "outlined" ? "50" : colorDepth;
  };

  const updatedColorDepth = updateColorDepth(variant, colorDepth);
  const borderColorDepth = noBorder
    ? colorDepth
    : getNextColorDepth(colorDepth);

  const getDisplayValue = () => {
    if (!value) return "";
    return String(value);
  };

  return (
    <div
      className={`select-none flex items-center justify-center rounded-full font-normal overflow-hidden ${
        onClick ? "cursor-pointer hover:opacity-80 transition-opacity" : ""
      }  ${borderClasses[size]} ${getDynamicPadding(size, numberValue)} 
      
      ${
        variant === "outlined"
          ? `border-${color}-${colorDepth}`
          : `border-${color}-${borderColorDepth}`
      }
      
      
      leading-none ${sizeClasses[size]} ${className} ${
        variant === "contained"
          ? `bg-${color}-${updatedColorDepth} text-${getTextColor(
              updatedColorDepth
            )}`
          : `text-${color}-${colorDepth} bg-transparent`
      } ${noBorder ? "border-transparent" : ""}`}
      onClick={onClick}
    >
      {prefix}
      {getDisplayValue()}
    </div>
  );
};

export default InfoCircle;
